
const withGlobal = require('with-global');

const $ = require('jquery');
const moment = require('moment');

withGlobal({
	$,
	jQuery: $,
	moment,
}, function () {
	require('drmonty-datatables-plugins/sorting/datetime-moment.js');
});

const _ = require('lodash');

_.each([
	'YYYY-MM-DDTHH:mm:ss.SSSSZ',
	'DD.MM.YYYY',
	'DD.MM.YYYY HH:mm:ss',
], function (fmt) {
	$.fn.dataTable.moment(fmt);
});
